<template>
    <div>
        <div>
            <span class="timeline-key">Old Expiry Date </span>: {{extra.old_expiry_date}}<br>
            <span class="timeline-key">New Expiry Date </span>: {{extra.new_expiry_date}}<br>
            <file-display :src="extra.image"/>
        </div>
    </div>
</template>

<script>
    import FileDisplay from "../../FileDisplay";
    export default {
        name: "ExpiryDateChanged",
        components: {FileDisplay},
        props: ['extra', 'user'],
        computed: {
        },
        mounted() {
            // console.log(this.extra);
        }
    }
</script>
